/* eslint-disable react/no-unknown-property */
import React from 'react'

export default function TrailBackgroundSVG() {
  return (
    <div
      style={{
        position: 'absolute',
        zIndex: -99,
        top: 0,
        left: 0,
        opacity: 0,
      }}
      className="wil-svg-trail-background"
    >
      <svg
        width="1616"
        height="900"
        viewBox="0 0 1616 900"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="svg-trail-background-svg"
      >
        <path
          d="M1613.77 916.215C1577.17 811.428 1468.67 744.523 1358.86 728.24C1249.05 711.957 1137.56 738.08 1031.24 769.963C924.919 801.846 819.079 839.988 708.421 848.757C597.762 857.526 478.538 832.566 399.855 754.252C345.744 700.363 311.59 622.991 242.489 590.443C179.959 561.015 106.796 576.874 38.7469 588.837C-29.3023 600.8 -107.099 605.803 -159.733 561.145C-213.161 515.785 -219.881 431.766 -191.45 367.705C-163.019 303.643 -106.878 256.289 -48.7424 217.151C9.39303 178.012 71.8484 144.265 122.821 96.154C173.793 48.0432 213.005 -18.6953 207.744 -88.5723C202.482 -158.449 140.156 -225.409 70.5376 -217.305"
          stroke="#034833"
          strokeWidth="3.00923"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeDasharray="6.3 11.82"
        />
      </svg>
    </div>
  )
}
